<script>
  import QRCode from "qrcode";
  import { panelController } from "../../../stores/service";
  import {
    buildMesaUrl,
    getRestaurantConfig,
  } from "../../../Controller/apps/paneListMesas/qrLinks";

  let cards = [];

  $: mesasService = $panelController.service.service.mesasService;
  $: restaurantConfig = getRestaurantConfig($panelController.service.listRatinggs);
  $: generateCards(mesasService, restaurantConfig);

  async function generateCards(mesas, config) {
    if (!config || !mesas || mesas.length === 0) {
      cards = [];
      return;
    }

    const service = $panelController.service;
    cards = await Promise.all(
      mesas.map(async (_, index) => {
        const n = index + 1;
        const url = buildMesaUrl(service, n);
        const qr = url
          ? await QRCode.toDataURL(url, {
              margin: 1,
              width: 320,
              color: { dark: "#2c3320", light: "#fbf6ea" },
            })
          : null;
        return { n, url, qr };
      }),
    );
  }

  function printAll() {
    window.print();
  }
</script>

<div class="mesas-qr">
  {#if !restaurantConfig}
    <p class="mesas-qr-empty">
      Configura el modo Restaurante en Configuración antes de generar códigos
      QR.
    </p>
  {:else if !mesasService || mesasService.length === 0}
    <p class="mesas-qr-empty">
      Configura el número de mesas en Configuración antes de generar códigos
      QR.
    </p>
  {:else}
    <div class="mesas-qr-actions">
      <button type="button" class="mesas-qr-print" on:click={printAll}>
        Imprimir todas las mesas
      </button>
    </div>

    <div class="mesas-qr-grid">
      {#each cards as card (card.n)}
        <div class="mesas-qr-card">
          <div class="mesas-qr-card-brand">
            {#if $panelController.service.ico}
              <img
                class="mesas-qr-card-logo"
                src={$panelController.service.ico}
                alt=""
              />
            {/if}
            <span>{$panelController.service.name}</span>
          </div>

          {#if card.qr}
            <img
              class="mesas-qr-card-code"
              src={card.qr}
              alt="Código QR de la mesa {card.n}"
            />
          {/if}

          <p class="mesas-qr-card-hint">Escanea para pedir servicio</p>
          <span class="mesas-qr-card-number">Mesa {card.n}</span>

          {#if card.qr}
            <a
              class="mesas-qr-card-download"
              href={card.qr}
              download="mesa-{card.n}-qr.png"
            >
              Descargar
            </a>
          {/if}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .mesas-qr-empty {
    margin: 0;
    padding: 2rem 1rem;
    text-align: center;
    color: var(--ink-faint);
    font-size: 0.95rem;
  }

  .mesas-qr-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1.25rem;
  }

  .mesas-qr-print {
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--cream);
    background: var(--olive-700);
    border: none;
    border-radius: 999px;
    padding: 0.55rem 1.1rem;
    cursor: pointer;
    transition: background 0.15s ease;
  }

  .mesas-qr-print:hover {
    background: var(--olive-900);
  }

  .mesas-qr-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1.25rem;
  }

  .mesas-qr-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1.25rem 1rem 1.1rem;
    background: var(--cream-deep);
    border: 1px solid var(--olive-200);
    border-radius: 16px;
    text-align: center;
  }

  .mesas-qr-card-brand {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-weight: 600;
    font-size: 0.82rem;
    color: var(--ink-soft);
  }

  .mesas-qr-card-logo {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    object-fit: cover;
  }

  .mesas-qr-card-code {
    width: 160px;
    height: 160px;
    border: 1px solid var(--olive-200);
    border-radius: 10px;
    background: var(--cream);
    margin: 0.25rem 0;
  }

  .mesas-qr-card-hint {
    margin: 0;
    font-size: 0.78rem;
    color: var(--ink-faint);
  }

  .mesas-qr-card-number {
    font-family: "Fraunces", ui-serif, Georgia, serif;
    font-weight: 600;
    font-size: 1.3rem;
    color: var(--ink);
  }

  .mesas-qr-card-download {
    margin-top: 0.35rem;
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--olive-700);
    text-decoration: none;
    border: 1.5px solid var(--olive-300);
    border-radius: 999px;
    padding: 0.35rem 0.9rem;
  }

  .mesas-qr-card-download:hover {
    border-color: var(--olive-700);
    background: var(--olive-100);
  }

  @media print {
    /* El resto de la página (barra superior, pestañas, y el footer global
       de la app con el logotipo grande de ratingg) no debe imprimirse -
       solo la cuadrícula de tarjetas. Se oculta todo el documento y se
       vuelve a mostrar únicamente esta cuadrícula y su contenido. */
    :global(body *) {
      visibility: hidden;
    }

    .mesas-qr-grid,
    .mesas-qr-grid * {
      visibility: visible;
    }

    .mesas-qr-grid {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      gap: 12mm;
    }

    .mesas-qr-card-download {
      display: none;
    }

    .mesas-qr-card {
      border: 1px dashed var(--olive-300);
      page-break-inside: avoid;
    }
  }
</style>
